/**
 * 下载模块api
 * date:2022 07 20
 */
import httpRequest from '@/utils/request.js';

/**获取列表 */
export const downloadList = (params = {}) => httpRequest.httpGet({
  url: '/service/download/record/page', params: {
    ...params
  }
});
/**下载 */
export const downloadDownload = (params = {},name,fileType) => httpRequest.download('/service/download/record/download', params,name,fileType);
/**获取进度 */
export const downloadProgress = (data) => httpRequest.httpPost('/service/download/record/progress', data);
/**获取详细 */
export const downloadDetail = (params = {}) => httpRequest.httpGet({
  url: '/service/download/record/detail', params: {
    ...params
  }
});
/**获取当前用户所有正在生成的文件进度 */
export const downloadUserProgress = (params = {}) => httpRequest.httpGet({
  url: '/service/download/record/userProgress', params: {
    ...params
  }
});
/**删除列表 */
export const downloadDel = (data) => httpRequest.httpdelete2('/service/download/record/delete', data);